import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MathService } from '../services/math/math.service';

@Pipe({ name: 'orderTotal',pure:false })
export class OrderTotalPipe implements PipeTransform {
  
  constructor(private translateService:TranslateService, private currencyPipe:CurrencyPipe, private mathService: MathService){
  }
  transform(order, displayMode?,type? ) { // type : products, calculated, sold
    const status = order.finances?.totals?.amountStatus;
    let display:string = '';
    const priceMode = order.market?.details?.priceMode||order.tournee.details.priceMode;
    if (!order.finances || !order.finances.VATExcluded || !order.finances.VATIncluded ){
      this.mathService.calculateOrderRevenue(order);
    }
    if(!displayMode || displayMode === 'priceOnly'){
      display += status=='estimated'?'±':''
      const currency = order.details?.currency.toUpperCase() || 'EUR';
      // Fallback sur `totals` : les commandes anciennes (pré-TVA) ou dont les
      // produits ne sont pas inline (stockés dans tournee-order-products) n'ont
      // pas de bucket VATIncluded/VATExcluded, et calculateOrderRevenue n'a alors
      // rien pu recalculer. Sans ce fallback, order.finances.VATIncluded[type]
      // plante (TypeError) et casse le rendu de la carte commande.
      const bucket = (priceMode === 'VATExcluded' ? order.finances?.VATExcluded : order.finances?.VATIncluded) || order.finances?.totals;
      const price = bucket ? bucket[type] : undefined;
      display += this.currencyPipe.transform(price,currency);
    }
    if(!displayMode || displayMode === 'detailsOnly'){
      display += priceMode === 'VATExcluded' ? (' ' + this.translateService.instant('tax.VATExcludedShort')): '';
    }
    return display;
  }
}